import axios from "axios";

export default async function fetchCurrenciesData() {
  const url = `${
    process.env.NEXT_PUBLIC_CURRENCY_CDN
  }?q=${new Date().getTime()}`;
  let result = null;
  const res = await axios({
    method: "get",
    url: url,
  });
  if (res.status === 200) {
    result = res.data;
    console.log("🚀 ~ fetchCurrenciesData ~ result:", result);
  }
  return result;
}
